// extracted by mini-css-extract-plugin
export default {"button":"PrintResults_button__vmSGw","loading":"PrintResults_loading__3vk3U"};